import React from 'react';
import FieldMapSelector from '../components/fieldmap/FieldMapSelector';
import { Box } from '@mui/material';

const Component = (props) => {
  return (
    <Box sx={{
      width: '100%',
      display: 'flex',
      flex: 1,
    }}>
      <FieldMapSelector />
    </Box>
  );
};


export default Component;
